import { useSelector } from 'react-redux'

import type { RecipeCoreId, RecipeUUID } from 'reducers/menu-recipes/recipes'
import { getRecipeIdByCoreId } from 'selectors/menu-recipes/getRecipeIdByCoreId'

/**
 * Returns the recipe uuids that matches the core ids
 */
export const useRecipeIdByCoreId = (id: RecipeCoreId): RecipeUUID | null =>
  useSelector(getRecipeIdByCoreId(id))
